// i18n area 'networks' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.de-DE.meta.json.
import type { enUS } from './networks'

export const deDE: typeof enUS = {
  networks: {
    common: {
      name: 'Name',
      scope: 'Scope',
      operState: 'Status',
      actions: 'Aktionen',
      create: 'Erstellen',
      close: 'Schließen',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      save: 'Speichern',
      editError: 'Änderung fehlgeschlagen',
      search: 'Nach Name suchen',
      empty: 'Noch nichts hier',
      saveError: 'Speichern nicht möglich',
      loadError: 'Laden nicht möglich — ist das TVirt-Backend erreichbar?',
      createError: 'Erstellung fehlgeschlagen',
      deleteError: 'Löschen fehlgeschlagen',
      deleteConfirmTitle: '{name} löschen?',
      deleteConfirmBody: 'Die Operation ist nicht umkehrbar.',
      nameHint: 'Kleinbuchstaben, Ziffern und Bindestriche (DNS-1123)',
      up: 'Aktiv',
      down: 'Inaktiv',
      unknown: 'Unbekannt',
      usedByVMs: 'VMs',
      emptyTable: 'Keine Einträge — fügen Sie einen mit der Schaltfläche + hinzu'
    },
    dialogTabs: {
      general: 'Allgemein',
      base: 'Basisdefinition',
      advanced: 'Erweiterte Konfiguration',
      reserved: 'Für TVirt reservierte Ranges',
      position: 'Position',
      network: 'Netzwerkkonfiguration',
      hosts: 'Teilnehmende Knoten'
    },
    reservedRanges: {
      note: 'Dies sind die für TVirt reservierten IP-Ranges, die es nutzen kann, um VMs, Containern usw. automatisch eine Adresse zuzuweisen. HINWEIS: die IPs in diesen Ranges dürfen außerhalb von TVirt nicht von externen Diensten oder Appliances verwendet werden.',
      from: 'Von',
      to: 'Bis'
    },
    overlay: {
      title: 'Overlay-Netzwerke',
      createTitle: 'Overlay-Netzwerk erstellen',
      editTitle: 'Overlay-Netzwerk bearbeiten',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — automatisch zugewiesen, wenn leer',
      subnet: 'Subnet',
      subnetHint: 'Der CIDR des Overlays — das IPAM leitet daraus automatisch seinen Registereintrag ab',
      mtu: 'MTU',
      weight: 'Gewicht',
      ceilMbps: 'Obergrenze (Mbps)',
      fairnessHint: 'Das Gewicht greift nur bei Konkurrenz: auf einer freien Leitung darf jedes Netz die volle Bandbreite nutzen. Die Obergrenze gilt dagegen immer.',
      contention: 'Konkurrenz',
      contentionTip: 'Mindestens ein Knoten beobachtet Drops oder Overlimits MIT Rückstau auf der Klasse dieses Netzwerks: Die Uplink-Bandbreite ist umkämpft und die Gewichte greifen. Wie viel und seit wann steht in den net.shaping.*-Reihen des Knotens.',
      firewallPolicy: 'Firewall-Richtlinie',
      hosts: 'Hosts',
      hostsTitle: 'Teilnehmende Knoten',
      hostsHint: 'Jeder Knoten deklariert seinen Underlay-Endpoint — ein Select über die REALEN Adressen des Knotens, gelesen aus seiner Netzwerkkonfiguration; die optionale Overlay-Adresse muss in der Subnet liegen. Die Teilnahme ist die Placement-Vorgabe.',
      hostNode: 'Knoten',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Wählen Sie zuerst den Knoten',
      hostAddress: 'Adresse auf dem Overlay (optional)',
      hostAddressOutside: 'Außerhalb des Overlay-Subnetzes ({cidr})',
      addHost: 'Knoten hinzufügen',
      observedAt: 'Beobachtet am',
      attachedNics: 'Verbundene NICs'
    },
    services: {
      title: 'Netzwerkdienste',
      createTitle: 'Netzwerkdienst erstellen',
      editTitle: 'Netzwerkdienst bearbeiten',
      kind: 'Typ',
      kindCategory: 'Dienste',
      selectKindHint: 'Wählen Sie den Diensttyp — der Daemon darunter ist ein Implementierungsdetail, das TVirt für Sie verwaltet.',
      kindLabel: {
        dhcp: 'DHCP-Server',
        ntp: 'NTP-Server',
        vpn: 'VPN-Server',
        dns: 'DNS-Server',
        gateway: 'Gateway',
        'lb-rp': 'Load Balancer und Reverse Proxy',
        floatip: 'Floating IP'
      },
      kindDesc: {
        dhcp: 'Vergibt Adressen auf den bedienten Subnets — die Pools leiten sich aus Subnet, Gateway und den für TVirt reservierten Ranges des Netzwerks ab.',
        dns: 'Autoritatives DNS über die deklarierten Zonen — die Records leiten sich aus dem IPAM plus Ihren manuellen ab.',
        gateway: 'Der Knoten agiert als Gateway für ein Netzwerk — NAT (DNAT, 1:1, SNAT/Masquerade) plus statisches Routing zwischen den angeschlossenen Netzwerken, selbstheilend by Design.',
        'lb-rp': 'Load Balancer / Reverse Proxy vor deinen Diensten — L4- oder L7-Listener über Pools von Mitgliedern oder über die bereiten Instanzen eines Pods, im laufenden Betrieb umkonfiguriert.',
        ntp: 'Der Zeitdienst der Netzwerke — Relay externer Upstream-Server, oder die Uhr des Knotens, den Clients serviert.',
        vpn: 'Ein VPN-Konzentrator auf dem Knoten — WireGuard oder OpenVPN, Ihre Wahl: Fernzugriff für mobile Clients oder ein Site-to-Site-Tunnel zwischen zwei Netzwerken.',
        floatip: 'Eine Adresse, die immer nur auf einer gesunden App-Instanz oder einem Pod liegt und beim Ausfall zum nächsten gesunden Ziel wandert — Failover ohne Daemons; die Lastverteilung bleibt beim Load Balancer.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Die Floating IP lebt im gewählten Netz als ZUSÄTZLICHE Adresse im eigenen Namensraum der haltenden Instanz: keine Ports, keine Lastverteilung, kein NAT — die Client-IP bleibt echt.',
        address: 'Floating IP',
        targets: 'Ziele',
        targetsHint: 'In PRÄFERENZ-Reihenfolge: das erste gesunde Ziel hält die Adresse. Ein Pod steht für alle seine Instanzen, nach Replik; jedes Ziel hat sein eigenes Gesundheitskriterium. Jedes Ziel muss am selben Netz hängen.',
        targetKind: 'Ziel',
        targetApp: 'App-Instanz',
        targetPod: 'Pod (alle Instanzen)',
        targetRef: 'Welches',
        health: 'Gesundheit',
        healthRunning: 'Läuft (jeder Container bereit)',
        healthTcp: 'TCP-Verbindung',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Pfad',
        addTarget: 'Ziel hinzufügen',
        moveUp: 'Nach oben',
        moveDown: 'Nach unten',
        preempt: 'Preempt',
        preemptHint: 'Aus (Standard): ein gesunder Halter behält die Adresse, auch wenn ein höheres Ziel zurückkommt — kein Flapping. An: das erste gesunde Ziel hält sie immer.',
        holder: 'Halter',
        noHolder: 'kein gesundes Ziel',
        since: 'seit',
        verdicts: 'Beobachtete Ziele',
        healthy: 'gesund',
        unhealthy: 'ungesund',
        noVerdict: 'Noch nicht entschieden — der Autoritätsknoten schreibt das erste Urteil beim nächsten Durchlauf.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Diese Instanz hält die Floating IP {address} des Dienstes {service}'
      },
      poolSource: 'Endpunkte',
      poolSourceMembers: 'Statische Mitglieder',
      poolSourcePod: 'Die bereiten Instanzen eines Pods',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Die Endpunkte folgen dem Pod: eine Instanz kommt hinzu, wenn sie mit jedem Container bereit läuft, und verlässt sofort, wenn sie herunterskaliert wird oder stirbt. Der aktive Check ist standardmäßig an.',
      poolBackendCount: 'die bereiten Instanzen des Pods {pod} auf Port {port}',
      node: 'Knoten',
      enabled: 'Aktiviert',
      parked: 'Geparkt',
      subnets: 'Subnets',
      subnetsHint: 'Die von dieser Instanz bedienten IPAM-Subnets — die Pools leiten sich aus CIDR, Gateway und den für TVirt reservierten Ranges ab',
      noSubnets: 'Keine IPAM-Subnet — deklarieren Sie zuerst ein logisches Fabric-Netzwerk (oder eine Overlay-Subnet): das IPAM leitet sich daraus ab',
      iface: 'Listening-Schnittstelle',
      ifaceHint: 'Die Host-Schnittstelle, auf der der Dienst seinen Socket öffnet (z. B. eine Bridge) — erforderlich: ein Netzwerkdienst ist in sich geschlossen, "alle Schnittstellen" gibt es nicht mehr',
      dns: 'DNS-Server',
      domain: 'Domain',
      detail: 'Bedient',
      subnetCount: '{n} Subnets',
      zones: 'Zonen',
      zonesHint: 'Nur autoritativ — der Daemon rekursiert nie. Die A-Records leiten sich aus den deklarierten Adressen der Knoten in den referenzierten IPAM-Subnets ab; der Reverse-Schalter bedient auch die zugehörigen in-addr.arpa-Zonen (PTR). Eine Zone wird flottenweit von höchstens einer DNS-Instanz bedient. Der optionale Nameserver ist der FQDN, der statt des Defaults ns.<zone> in die NS/SOA-Records geschrieben wird; fällt er in die Zone, leitet sich sein A-Record trotzdem vom bedienenden Knoten ab.',
      zoneName: 'Zonenname',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM-Subnets',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuelle Records',
      zoneRecordsHint: 'Einer pro Zeile: name TYP wert — Typen A, CNAME, MX, TXT. Bei einer Namenskollision gewinnt der manuelle Record über den abgeleiteten.',
      addZone: 'Zone hinzufügen',
      lbListeningHint: 'Die Instanz deklariert EIN Listening-Netzwerk und EINE Adresse — jeder Listener bindet sie auf seinem eigenen Port; eine zweite Adresse ist ein zweiter Dienst.',
      listeners: 'Listener',
      listenersHint: 'Jeder Listener bindet die Adresse der Instanz auf seinem eigenen Port im Modus L4 (TCP-Passthrough — die Bytes werden nie geöffnet) oder L7 (HTTP) und leitet an einen der Pools unten weiter. Ein Adresse/Port-Paar wird von höchstens einer Instanz pro Node bedient. Änderungen greifen im Flug — kein Neustart, keine verlorenen Verbindungen.',
      listenerName: 'Name',
      listenerMode: 'Modus',
      modeL7: 'L7 — HTTP-Reverse-Proxy',
      modeL4: 'L4 — TCP-Passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Listener hinzufügen',
      pools: 'Pools',
      poolsHint: 'Die Backends, auf denen der Traffic landet: statische Mitglieder, balanciert per Round-Robin oder nach dem am wenigsten Beschäftigten, mit einem optionalen aktiven Health-Check, der kranke Mitglieder aus der Rotation nimmt.',
      poolName: 'Name',
      poolAlgorithm: 'Algorithmus',
      algoRoundRobin: 'Round Robin',
      algoLeastRequest: 'Am wenigsten beschäftigt',
      poolCheck: 'Health-Check',
      checkNone: 'Keiner',
      checkTcp: 'TCP-Verbindung',
      checkHttp: 'HTTP',
      poolCheckPath: 'Sondenpfad',
      poolInterval: 'Intervall (s)',
      poolMembers: 'Mitglieder',
      poolMembersHint: 'Eines pro Zeile: adresse:port, optional gefolgt von einem Gewicht (1-128) — z. B. 10.0.0.21:8080 2',
      addPool: 'Pool hinzufügen',
      memberCount: '{n} Mitglieder',
      listen: {
        assignment: 'Zuweisung',
        assignmentStatic: 'Statische Adresse',
        assignmentAuto: 'Automatisch (TVirt-reservierte Bereiche)',
        autoHint: 'TVirt zieht die Adresse aus den reservierten Bereichen des logischen Netzes und hält sie sticky — nie neu gezogen bei einem Edit oder Failover.',
        title: 'Listener',
        hint: 'Ein Netzwerkdienst ist in sich geschlossen: jeder Listener deklariert sein Netzwerk (Overlay, logisches Fabric-Netzwerk oder rohe Schnittstelle) und eine Adresse innerhalb seines Subnetzes — ein Listener pro Adresse, das Wildcard gibt es nicht mehr. DNS und NTP dürfen auf mehreren Netzwerken und mehreren Adressen dieser Netzwerke lauschen.',
        address: 'Listening-Adresse',
        add: 'Listener hinzufügen'
      },
      ntp: {
        mode: 'Synchronisierungsmodus',
        modeRelay: 'Relay externer Server',
        modeNodeClock: 'Uhr des Knotens',
        modeHint: 'Das Relay serviert die Zeit der deklarierten Upstream-Server; die Uhr des Knotens serviert die Zeit des bedienenden Knotens — die der Cluster ohnehin synchron hält',
        servers: 'Upstream-Server',
        serversHint: 'Kommagetrennt — Hostname oder IP-Adresse; der Dienst nimmt die Zeit von hier und serviert sie dem Netzwerk',
        port: 'Listening-Port',
        listening: 'Lauscht auf'
      },
      vpn: {
        engine: 'Engine',
        engineHint: 'Sie wählen sie, und sie ändert sich nie mehr: WireGuard ist modern, schnell und im Kernel; OpenVPN ist der Veteran der Kompatibilität (TCP, feindliche Netzwerke)',
        engineLocked: 'Die Engine ist unveränderlich — eine andere Engine ist ein neuer Dienst, Schlüssel und Zertifikate sind nicht portierbar',
        mode: 'Modus',
        modeRemote: 'Fernzugriff',
        modeSite: 'Site to site',
        modeHint: 'Der Fernzugriff gibt mobilen Clients eine Adresse im Tunnel; Site to site verbindet zwei Netzwerke',
        port: 'Listening-Port',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard spricht nur UDP',
        tunnelSubnet: 'Subnet des Tunnels',
        tunnelSubnetHint: 'Das Netzwerk, in dem die Clients leben — im IPAM-Register eingetragen, es entsteht und stirbt mit diesem Dienst',
        dnsServers: 'An die Clients gepushte DNS',
        routes: 'An die Clients gepushte Routen',
        routesHint: 'Kommagetrennte Netzwerke, die über den Tunnel erreichbar sind; die Subnet des Tunnels ist immer dabei',
        peers: 'Peers',
        peersHint: 'Lassen Sie den öffentlichen Schlüssel leer und TVirt erzeugt das Paar — und übergibt es dann mit dem Profil. Fügen Sie einen Schlüssel ein und der Peer behält seinen eigenen.',
        clients: 'Clients',
        clientsHint: 'Jeder Client erhält ein Zertifikat der eigenen CA dieses Dienstes. Einen Client zu entfernen WIDERRUFT ihn: die CRL wird sofort neu erzeugt.',
        peerName: 'Name',
        publicKey: 'Öffentlicher Schlüssel',
        publicKeyMinted: 'TVirt erzeugt ihn',
        peerAddress: 'Adresse im Tunnel',
        peerAddressHint: 'Leer = zugewiesen',
        allowedIps: 'Entfernte Subnets',
        allowedIpsHint: 'Kommagetrennt, über diesen Peer geroutet',
        endpoint: 'Endpoint',
        presharedKey: 'Pre-shared Key',
        keepalive: 'Keepalive (s)',
        addPeer: 'Peer hinzufügen',
        addClient: 'Client hinzufügen',
        auth: 'Authentifizierung',
        authTls: 'Zertifikate (TLS)',
        remote: 'Entfernter Endpoint',
        remoteHint: 'host:port der Gegenstelle — leer bedeutet, dass diese Seite wartet',
        peerRoutes: 'Entfernte Subnets',
        serverPublicKey: 'Öffentlicher Schlüssel dieses Servers',
        ca: 'Zertifizierungsstelle',
        listening: 'Lauscht auf',
        tunnel: 'Tunnel',
        peerCount: '{n} Peers',
        download: 'Profil herunterladen',
        downloadError: 'Das Profil konnte nicht exportiert werden',
        lastHandshake: 'Letzter Handshake',
        never: 'nie',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Verbunden',
        idle: 'Inaktiv'
      },
      gateway: {
        attach: 'Typ des Listening-Netzwerks',
        attachOverlay: 'Overlay-Netzwerk',
        attachNetwork: 'Logisches Fabric-Netzwerk',
        attachInterface: 'Rohe Schnittstelle',
        overlay: 'Overlay-Netzwerk',
        network: 'Logisches Netzwerk',
        interface: 'Schnittstellenname',
        interfaceHint: 'Eine Host-Schnittstelle, die TVirt nicht verwaltet — die Adresse wird auf Treu und Glauben übernommen',
        address: 'Listening-Adresse (Gateway)',
        addressHint: 'Die Gateway-Adresse, auf die die Clients zeigen — innerhalb der Subnet des Listening-Netzwerks',
        dnatTitle: 'DNAT-Regeln',
        dnatHint: 'Ziel-NAT: der Traffic im Match wird auf eine neue Adresse (und optional einen neuen Port) umgeleitet. Jedes Protokoll der Liste — die Ports dort, wo das Protokoll sie trägt.',
        snatTitle: 'SNAT-Regeln',
        snatHint: 'Quell-NAT: der Traffic im Match geht mit umgeschriebener Quelle hinaus — eine explizite neue Adresse (und optional ein neuer Port), oder Masquerade auf der Ausgangsadresse, wenn leer gelassen.',
        oneToOneTitle: '1:1-NAT-Regeln',
        oneToOneHint: 'Jedes Paket an die externe Adresse wird auf die interne abgebildet, und der interne Host geht als die externe hinaus — alle Protokolle, beide Richtungen.',
        external: 'Externe Adresse',
        internal: 'Interne Adresse',
        addOneToOne: '1:1-Regel hinzufügen',
        family: 'Familie',
        protocol: 'Protokoll',
        source: 'Quelle (Adresse/Subnet)',
        destination: 'Ziel (Adresse/Subnet)',
        invert: 'NOT',
        srcPorts: 'Quell-Ports',
        dstPorts: 'Ziel-Ports',
        dstPortsHint: 'Port oder Range (80, 8000-8099)',
        toAddress: 'Neue Adresse',
        toPort: 'Neuer Port',
        snatTo: 'Neue Quelle (leer = Masquerade)',
        snatToHint: 'Explizite Quelladresse; leer = Masquerade auf der Ausgangsadresse',
        addDnat: 'DNAT-Regel hinzufügen',
        addSnat: 'SNAT-Regel hinzufügen',
        routesTitle: 'Statische Routen',
        routesHint: 'Der Knoten routet zwischen den Netzwerken, an die er angeschlossen ist (IP-Forwarding ist aktiv); diese Routen fügen Erreichbarkeit darüber hinaus hinzu — reiner Kernel, dynamisches Routing kommt mit einem späteren Round.',
        routeDestination: 'Ziel-Subnet',
        routeGateway: 'Next Hop',
        routeMetric: 'Metrik',
        addRoute: 'Route hinzufügen',
        listening: 'Lauscht auf',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} Routen'
      },
      unknownSince: 'Unbekannt — letzter Report vor {m} min',
      lastWord: 'Letztes Wort',
      reportObservedAt: 'Letzter Report',
      lastErrorRow: 'Letzter Fehler',
      recordsCount: '{n} manuelle Records',
      phase: {
        configured: 'Konfiguriert',
        running: 'Läuft',
        error: 'Fehler'
      },
      authorityNode: 'Authority (Zuweisung)',
      preferredNode: 'Bevorzugter Knoten',
      preferredNodeHint: 'Eine weiche Präferenz, nie eine Einschränkung: Bei der nächsten Placement-Entscheidung landet die Instanz hier, wenn das Mitglied geeignet ist — allein bewegt sie nichts; der Zug ist "Authority übertragen".',
      noPreference: 'Keine Präferenz (automatisches Placement)',
      moving: 'In Bewegung',
      movingTooltip: 'Hier beobachtet, während die Authority {node} zuweist: Der Zug konvergiert.',
      placement: {
        title: 'Placement',
        loading: 'Bestandsaufnahme läuft…',
        loadError: 'Die Placement-Bestandsaufnahme hat nicht geantwortet — versuchen Sie es später erneut.',
        draftHint: 'Die Bestandsaufnahme berechnet sich aus der deklarierten Netzanbindung: Sie erscheint, sobald der Dienst existiert. Die Erstellung wird abgelehnt, wenn kein Mitglied ihn bedienen kann, und die Ablehnung nennt den Mechanismus, der die Menge geleert hat.',
        eligibleCount: '{n} von {m} Mitgliedern können diese Instanz bedienen',
        recommended: 'Empfohlen',
        eligible: 'Geeignet',
        notEligible: 'Nicht geeignet',
        blockedReachability: 'das Netz kommt auf diesem Mitglied nicht an',
        blockedRequireTag: 'blockiert durch ein erforderliches Tag (requireNodes)',
        blockedExcluded: 'von der Simulation ausgeschlossen',
        preferenceUnknown: 'ist kein Mitglied des Clusters (mehr)',
        preferenceIgnored: 'Die Präferenz "{node}" ist heute nicht geeignet: {reason}. Die Empfehlung der Bestandsaufnahme setzt sich durch — nie ein Fehler, der Dienst lebt anderswo.',
        emptyReachability: 'Kein Mitglied kann diese Instanz bedienen: Das Netz kommt nirgends an — kein Feilen an den Tags wird helfen. Verkabeln Sie den Knoten, oder verschieben Sie den Dienst dorthin, wo das Netz ist.',
        emptyRequireTag: 'Kein Mitglied kann diese Instanz bedienen: Die erforderlichen Tags haben die Menge geleert — entfernen Sie den requireNodes-Eintrag, oder taggen Sie ein Mitglied.',
        spof: 'Single Point of Failure',
        spofDetail: 'Nur ein einziges Mitglied kann die Instanz beherbergen: Beim Ausfall kann der Failover nirgendwohin ausweichen. Ein Multi-Listener-Dienst zieht als EINHEIT um — der Kandidat muss ALLE seine Netze sehen: Das ist der Preis.',
        whatIf: 'Abwesende Mitglieder simulieren',
        whatIfHint: 'Das What-if des Drains: Fragen Sie VOR der Evakuierung, statt es beim Failover zu entdecken.',
        survives: 'Mit {nodes} abwesend hat der Dienst noch ein Zuhause.',
        notSurvives: 'Die Evakuierung von {nodes} lässt diesen Dienst AM BODEN: Die abgeleitete Einschränkung gewinnt gegen die Verfügbarkeit (R30) — ein lebender Daemon dort, wo das Netz nicht ankommt, dient niemandem und alarmiert niemanden.',
        transfer: 'Authority übertragen',
        transferError: 'Übertragung fehlgeschlagen',
        transferTarget: 'Ziel-Mitglied',
        transferHint: 'Nur geeignete Mitglieder werden angeboten — eine Präferenz innerhalb der gültigen Menge, nie ein Override. Kein Task: Der nächste Durchlauf der Worker IST der Zug (der alte Knoten mäht, der neue baut auf).'
      }
    },
    fabric: {
      tabDerivation: 'Ableitung',
      importNetwork: 'Aus einer anderen Fabric importieren',
      importTitle: 'Ein logisches Netzwerk importieren',
      importHint: 'Der Import ist der explizite Beitritt: Das Netzwerk bleibt beim Eigentümer (gleiche Identität, gleicher Stem, gleiche Bridge tvf-<stem>) und wird von hier auf die Ports/LAGGs dieser Fabric gemappt — Mappen HEISST behaupten, dass die Zustellung in derselben L2-Domäne wie beim Eigentümer mündet.',
      importPick: 'Netzwerk des Eigentümers',
      importNone: 'Nichts zu importieren: Die anderen Fabrics haben kein eigenes Netzwerk, das diese Fabric nicht schon kennt',
      importedNetworksTitle: 'Importierte Netzwerke',
      noImported: 'Kein importiertes Netzwerk',
      importedFrom: 'importiert aus {fabric}',
      importedBy: 'Importiert von: {list}',
      importedCount: '+{n} importiert',
      owner: 'Eigentümer',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Import entfernen',
      unimportConfirm: 'Den Import des Netzwerks {name} (Eigentümer {fabric}) aus dieser Fabric entfernen? Er wird abgelehnt, solange ein Port oder LAGG dieser Fabric es mappt oder ein Gast, eine App oder ein Dienst nur über dieses Bein bedient wird.',
      unimportRefused: 'Import noch in Gebrauch — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Dieser Knoten bezieht dieses Netzwerk bereits über eine andere Fabric, deren Mitglied er ist: Ein Knoten nimmt ein geteiltes Netzwerk über EIN einziges seiner Beine (zwei Uplinks desselben L2 in einer Bridge ohne STP sind eine Schleife). Hebe das Mapping auf den Ports oder dem LAGG einer der beiden Fabrics auf.',
          otherFabricDerived: 'Das Dokument trägt den Block einer Fabric, zu der der Knoten kein Kabel mehr deklariert: Wende zuerst den Plan dieser Fabric an (er schlägt das Entfernen ihrer Devices vor), oder übernimm sie mit take-ownership, wenn die Fabric nicht mehr existiert.'
        },
        hint: 'Der O.3-Ableitungsplan: für jeden verkabelten Knoten der Zustand, das Diff abgeleitet-vs-aktuell, die DEKLARIERTE Bond-Topologie, die Dual-Stack-Flips und die strukturierten Ablehnungen/Warnungen. Nur Lesen bis zum EXPLIZITEN Apply — nichts landet je von selbst auf einem Knoten.',
        refresh: 'Plan neu laden',
        empty: 'Kein Knoten ist an diese Fabric verkabelt (und keiner trägt noch ihren Block).',
        refusal: 'Ablehnung',
        warning: 'Warnung',
        generation: 'Dokument-Generation {n}',
        state: {
          manual: 'Manuell',
          derived: 'Abgeleitet',
          diverged: 'Abgewichen'
        },
        topologyTitle: 'Deklarierte Topologie',
        members: 'Mitglieder',
        primary: 'primär',
        held: 'auf EINEM Mitglied gehalten',
        form: {
          perNetworkBond: 'Bond pro Netz',
          singleBond: 'Einzelner Fallback-Bond',
          laggBond: 'LACP-Bond (LAGG)',
          singlePort: 'Einzelner Port'
        },
        colAction: 'Aktion',
        colKind: 'Art',
        colDevice: 'Device',
        colDetail: 'Detail',
        action: {
          add: 'hinzufügen',
          remove: 'entfernen',
          replace: 'ersetzen'
        },
        diffEmpty: 'Kein ausstehendes Diff — das angewandte Dokument deckt sich mit dem Render.',
        diffBlocked: 'Kein Diff: die Ablehnungen oben blockieren diesen Knoten.',
        phasePlanned: 'geplant (Schritt 1 von 3)',
        phaseDraining: 'am Leerlaufen (Schritt 2 von 3)',
        probeUnobserved: 'Drain-Sonde: nie gemeldet — die Leere ist UNBEKANNT (ein Retire würde jetzt abgelehnt).',
        probeFailed: 'Drain-Sonde: Beobachtung FEHLGESCHLAGEN — die bekannten Zeitstempel werden mitgeführt, nie ein «leer», das niemand gemessen hat.',
        probeActive: {
          one: 'Drain-Sonde: {n} bestehende Verbindung noch auf der alten Adresse',
          other: 'Drain-Sonde: {n} bestehende Verbindungen noch auf der alten Adresse'
        },
        probeLastActive: 'letzte Aktivität {time}',
        probeEmpty: {
          one: 'Drain-Sonde: leer seit {n} Minute',
          other: 'Drain-Sonde: leer seit {n} Minuten'
        },
        probeEmptyUnknown: 'Drain-Sonde: leer (seit wann ist unbekannt).',
        impact: '{nics} vNIC und {apps} App auf diesem Knoten nutzen diese Netze: {list}',
        apply: 'Auf diesen Knoten anwenden',
        applyTitle: 'Ableitung anwenden — {node}',
        applyIntro: 'Die abgeleitete Konfiguration schreibt das Netzwerkdokument von {node} neu ({n} Änderungen), durch dieselbe Tür wie der Host-Network-Editor — NetworkManager-Checkpoint und ehrliche Probe inklusive. Die Plan-Warnungen unten reisen mit: vor dem Bestätigen lesen.',
        applyError: 'Apply fehlgeschlagen',
        applyRefused: 'Der Knoten hat abgelehnt:',
        planMoved: 'Die Fabric hat sich nach dieser Vorschau geändert — NICHTS wurde angewandt. Der Plan wurde neu geladen: erneut ansehen und wiederholen.',
        retire: 'Stilllegen',
        retireTitle: 'Punkt ohne Wiederkehr — Stilllegung von {address}',
        restore: 'Wiederherstellen',
        restoreTip: 'Zurück zum Snapshot vor dem Apply (Generation {previous}) — das Undo um einen Schritt (H13)',
        restoreTitle: 'Vorheriges Dokument wiederherstellen — {node}',
        restoreIntro: 'Das Netzwerkdokument von {node} kehrt zum Snapshot vor dem letzten Apply zurück (Generation {previous}), neu geschrieben als Generation {next} anstelle von {current}. Der Worker konvergiert es wie jedes andere Dokument.',
        restoreRedo: 'Das ersetzte Dokument wird zum neuen Snapshot: erneutes Wiederherstellen ist das Redo.',
        restoreClosesChain: 'Der Snapshot ist das manuelle Dokument vor der Ableitung: Die Kette endet hier — kein weiteres Undo, der Knoten ist bis zum nächsten Apply manuell.',
        restoreConfirm: 'Wiederherstellen',
        restoreError: 'Wiederherstellung fehlgeschlagen',
        retireIntro: 'Dies entfernt {address} ({network}) endgültig von {point}. Danach ist der Weg zurück der UMGEKEHRTE Flip — die alte Adresse durch dieselbe Engine neu deklarieren — nie eine blinde Wiederherstellung.',
        retireOld: 'Alte Adresse (entfernt)',
        retireNew: 'Neue Adresse (bleibt)',
        retireEmptyFact: 'Die Drain-Sonde meldet die Adresse leer: diese Entfernung trennt keine beobachtete Verbindung.',
        retireConfirm: 'Adresse stilllegen',
        severActiveLoss: {
          one: '{n} bestehende Verbindung auf der alten Adresse kappen — sie stirbt mit diesem Akt',
          other: '{n} bestehende Verbindungen auf der alten Adresse kappen — sie sterben mit diesem Akt'
        },
        severUnknownLoss: 'Das UNBEKANNTE akzeptieren: die Sonde hat diese Adresse nie beobachtet (oder die Beobachtung schlägt fehl) — lebende Verbindungen können gekappt werden.'
      },
      title: 'Fabric',
      createTitle: 'Fabric erstellen',
      networks: 'Netzwerke',
      switches: 'Switches',
      ports: 'Ports',
      laggs: 'LAGGs',
      subnets: 'Subnets',
      tabOverview: 'Übersicht',
      tabNetworks: 'Logische Netzwerke',
      tabSwitches: 'Switches',
      overviewHint: 'Die Fabric auf einen Blick: jedes logische Netzwerk mit MTU und Subnet (die VLANs leben nur in den Mappings pro Port/pro LAGG — dasselbe Netzwerk kann auf verschiedenen Ports mit verschiedenen Tags reisen). Die Fabric ist das Register einer EXTERNEN Infrastruktur — TVirt beobachtet und deklariert, provisioniert nie und rührt nur die unter seiner Kontrolle registrierten NICs an.',
      absorptionHint: 'Jede hier deklarierte Subnet LEITET ihren Eintrag im IPAM-Register in derselben Schreiboperation AB — sie lebt und stirbt mit dem Netzwerk.',
      scopeFixedHint: 'Der Scope ist fest auf die Cluster-Wurzel gesetzt: physische Infrastruktur ist per Definition clusterweit.',
      networksHint: 'Jedes Netzwerk trägt eine verpflichtende MTU (Default 1500) und eine verpflichtende Subnet; hier deklarierte Gateways, DNS-Server und statische Routen sind die EINZIGE QUELLE für Server-NICs, Apps und Netzwerkdienste.',
      switchesHint: 'Das manuelle Register: ein Port ist unbenutzt, gemappt (untagged und pro VLAN-Tag auf die logischen Netzwerke) oder Mitglied eines LAGG — ein Mitglied trägt keine eigenen Mappings.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Verpflichtend — das IPAM leitet daraus automatisch seinen Registereintrag ab',
      nodeAddressing: 'Knoten-Adressierung',
      nodeAddressingNone: 'Keine — keine Adresse pro Knoten',
      nodeAddressingPool: 'Pool — eine feste Adresse pro versorgtem Knoten',
      nodeAddressingHint: 'Mit Pool weist die Fabric-Ableitung jedem versorgten Knoten eine Adresse aus den für TVirt reservierten Bereichen zu (nach Zuweisung fest).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Reservierte Ranges',
      dns: 'DNS-Server (kommagetrennt)',
      dnsShort: 'DNS',
      singleSourceHint: 'Hier deklarierte Gateways, DNS und Routen sind die einzige Quelle — Server-NICs, Apps und Netzwerkdienste schöpfen von hier',
      routesTitle: 'Statische Routen',
      routeDestination: 'Ziel (CIDR)',
      routeVia: 'Via (Next Hop)',
      portUsed: 'Benutzt',
      vlanMappings: 'VLAN-Mappings',
      vlanTag: 'VLAN-Tag',
      vlanNetwork: 'Logisches Netzwerk',
      nameTaken: 'Name in der Fabric bereits verwendet',
      addNetwork: 'Netzwerk hinzufügen',
      editNetwork: 'Netzwerk bearbeiten',
      deleteNetwork: 'Netzwerk entfernen',
      deleteNetworkConfirm: 'Das logische Netzwerk {name} aus der Fabric entfernen? Seine abgeleitete Subnet im IPAM stirbt mit ihm (abgelehnt, solange ein Dienst oder eine App es nutzt). Port- und LAGG-Zuordnungen, die darauf zeigen, werden entfernt.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Physische Position (optional) — dasselbe Vokabular wie die Server-Platzierung; nur deklarativ',
      addSwitch: 'Switch hinzufügen',
      editSwitch: 'Switch bearbeiten',
      deleteSwitch: 'Switch entfernen',
      deleteSwitchConfirm: 'Den Switch {name} mit allen seinen Ports entfernen? Die LAGGs schrumpfen entsprechend (und sterben unter zwei Ports).',
      addPort: 'Port hinzufügen',
      editPort: 'Port bearbeiten',
      deletePort: 'Port entfernen',
      deletePortConfirm: 'Den Port {name} entfernen?',
      untagged: 'Untagged',
      tagged: 'Tagged (Tag:Netzwerk)',
      taggedShort: 'Tagged',
      portCabling: 'Verkabelung',
      portState: 'Status',
      stateUnused: 'unbenutzt',
      stateMapped: 'gemappt',
      laggPortGuard: 'Ein Mitgliedsport eines LAGG wird von der LAGG-Seite bearbeitet',
      laggsTitle: 'LAGGs',
      laggsHint: 'Ein LAGG ist 2+ Ports in LACP und kann Switches überspannen (MLAG, transparent); nur unbenutzte Ports treten bei, der LAGG ist die Mapping-Oberfläche, ein entfernter Port kehrt zu unbenutzt zurück.',
      addLagg: 'LAGG hinzufügen',
      editLagg: 'LAGG bearbeiten',
      deleteLagg: 'LAGG entfernen',
      deleteLaggConfirm: 'Den LAGG {name} entfernen? Seine Mitgliedsports kehren zu unbenutzt zurück.',
      lacpRate: 'LACP-Rate',
      laggPorts: 'Mitgliedsports (2+)',
      laggPortsHint: 'Nur unbenutzte Ports treten bei — geben Sie zuerst einen gemappten Port frei',
      noNetworks: 'Kein logisches Netzwerk deklariert.',
      noSwitches: 'Kein Switch deklariert.',
      noLaggs: 'Kein LAGG deklariert.',
      staleConflict: 'Ein anderer Bediener hat diese Fabric geändert, während du sie bearbeitet hast: Das Speichern wurde abgelehnt, damit seine Arbeit nicht gelöscht wird. Deine Änderungen sind noch hier, unverändert. Die aktualisierte Fabric wurde bereits neu geladen: Bestätige erneut, um sie darauf anzuwenden, oder brich ab und sieh dir an, was sich geändert hat.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Nur abgeleitet: jede Subnet entsteht aus einem logischen Fabric-Netzwerk oder einem Overlay — bearbeitet wird an der Quelle. Die zugewiesenen Adressen zeigen, WER sie hält; die für TVirt reservierten Ranges sind die Pools der automatischen Zuweisung.',
      search: 'Nach Name, CIDR oder Adresse suchen',
      empty: 'Kein Netzwerk — deklarieren Sie ein logisches Fabric-Netzwerk oder eine Overlay-Subnet: das IPAM leitet sich automatisch daraus ab.',
      reserved: 'Für TVirt reservierte Ranges',
      address: 'Adresse',
      origin: 'Herkunft',
      origin_declared: 'deklariert',
      origin_observed: 'beobachtet',
      holder: 'Gehalten von',
      noAddresses: 'Keine Adresse in dieser Subnet bekannt.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'An der Quelle bearbeiten'
    },
    firewall: {
      title: 'Firewall-Gruppen',
      createTitle: 'Neue Firewall-Gruppe',
      editTitle: 'Firewall-Gruppe bearbeiten',
      empty: 'Keine Firewall-Gruppen — legen Sie eine an: ein wiederverwendbares Regelvokabular, von den Gast-NICs per Name referenziert.',
      nameHint: 'Buchstaben, Ziffern und innenliegende . - _; eindeutig innerhalb seines Scopes (Gleichnamige anderswo unterscheiden sich durch /scope/name)',
      description: 'Beschreibung',
      descriptionHint: 'Eine Zeile Absicht, gezeigt überall dort, wo die Gruppe gewählt wird',
      enforced: 'Auf dem Scope erzwungen',
      enforcedHint: 'Aus: reines Vokabular — die Regeln binden nur die NICs, die die Gruppe referenzieren. An: Die Regeln binden jede Gast-NIC mit eingeschalteter Firewall unter dem Scope der Gruppe, referenziert oder nicht.',
      enforcedChip: 'Erzwungen',
      enforcedChipHint: 'Die Regeln binden jede Gast-NIC mit eingeschalteter Firewall unter dem Scope der Gruppe, referenziert oder nicht',
      enforceWarning: 'Mit dem Erzwingen binden die Regeln beim nächsten Abgleich JEDE Gast-NIC mit eingeschalteter Firewall unter {scope}, auch ohne explizite Referenz — und innerhalb einer aktiven Chain ist das drop eines Vorfahren endgültig: Die Ebenen darunter öffnen es nicht wieder.',
      unenforceInfo: 'Mit dem Aufheben des Erzwingens bleiben die Regeln nur auf den NICs, die die Gruppe explizit referenzieren.',
      rules: 'Regeln',
      tabOverview: 'Übersicht',
      tabRules: 'Regeln',
      orderHint: 'Die Zeilenreihenfolge IST die Auswertungsreihenfolge innerhalb der Gruppe: Die erste passende Regel gewinnt.',
      statefulHint: 'Stateful ist implizit: Antworten auf zugelassenen Verkehr passieren von selbst (established/related akzeptiert, invalid verworfen — die Engine injiziert sie, von Hand schreibt man sie nie).',
      noRules: 'Keine Regeln — ein Vokabular im Aufbau: Es zu referenzieren ist zulässig und rendert nichts.',
      addRule: 'Regel hinzufügen',
      direction: 'Richtung',
      directionIn: 'Eingehend',
      directionOut: 'Ausgehend',
      action: 'Aktion',
      action_accept: 'Akzeptieren',
      action_drop: 'Verwerfen',
      action_reject: 'Ablehnen',
      protocol: 'Protokoll',
      protocolAny: 'Beliebig',
      ports: 'Ports',
      source: 'Quelle',
      dest: 'Ziel',
      comment: 'Kommentar',
      addressHint: 'IPv4-CIDR oder <Fabric>/<logisches Netzwerk>; leer = beliebig',
      moveUp: 'Nach oben',
      moveDown: 'Nach unten',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-Spoofing',
      nicGroups: 'Firewall-Gruppen',
      nicGroupsPlaceholder: 'Wählen Sie eine Gruppe…',
      nicGroupsHint: 'Die sichtbaren Gruppen, einschließlich derer der übergeordneten Scopes (nach unten nutzbar, wie die Tags)',
      nicGroupCount: { one: '{n} Firewall-Gruppe', other: '{n} Firewall-Gruppen' },
      nicOff: 'Firewall aus',
      pendingRestartHint: 'Firewall-Änderungen folgen dem Modell gespeichert/angewendet: Sie warten auf den nächsten Power-Cycle (PendingRestart). Von übergeordneten Scopes erzwungene Gruppen gelten, wenn die Firewall der NIC eingeschaltet ist.',
      appConvergeHint: 'Firewall-Änderungen gelten ab dem nächsten Abgleich des Containers. Von übergeordneten Scopes erzwungene Gruppen gelten, wenn die Firewall eingeschaltet ist.',
      enforcedAncestors: 'Von übergeordneten Scopes erzwungen',
      enforcedAncestorsHint: 'Diese Gruppe gilt für jede NIC unter ihrem Scope, deren Firewall EIN ist — der Schalter ist der Hauptschalter der NIC (aus = gar keine Chain, Vorfahren eingeschlossen); innerhalb einer aktiven Chain ist die Autorität des Vorfahren endgültig: Sein drop wird darunter nicht wieder geöffnet.'
    }
  }
}
